import { isObjectTypeId } from 'customer-data-objects/constants/ObjectTypeIds';

/**
 * See backend MetaTypeProto for full list of CrmObject type prefixes
 * https://git.hubteam.com/HubSpotProtected/CrmObjects/blob/master/CrmObjectsBase/src/main/proto/hubspot/crm/objects/crmobjects-core.proto#L414
 *
 */

export const isAppObjectTypeId = (objectType = '') => isObjectTypeId(objectType) && objectType.startsWith('1-');